module.exports = __webpack_public_path__ + "img/box2.deb085b9.png";